import { useEffect } from 'react';

import { urls } from '@repo/app-constants';
import { Kit } from '@repo/types';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { UpsellPlacement } from 'contexts/analytics/types';
import { useShowTinyPlusUpsell } from 'hooks/useShowTinyPlusUpsell';
import {
  RecommendedCard,
  RecommendedCardProps,
} from 'views/Home/HomeContent/RecommendedForYou/components/RecommendedCard';
import { getTinyPlusUpsellCard } from 'views/Home/HomeContent/RecommendedForYou/utils/getTinyPlusUpsellCard';

// Reuses the homepage "Recommended for you" Tiny+ upsell card for the
// contextual placements (action plan sidebar, baby
// resample action detail).
export const TinyPlusUpsellCard = ({
  kit,
  title,
  label,
  imgStyles,
  className,
  titleContainerClassName,
  leftColumnStyles,
  titleVariantMobile,
  labelVariantMobile,
  placement,
}: {
  kit?: Kit | null;
  title: string;
  label: JSX.Element;
  imgStyles?: string;
  className?: string;
  titleContainerClassName?: string;
  leftColumnStyles?: string;
  titleVariantMobile?: RecommendedCardProps['titleVariantMobile'];
  labelVariantMobile?: RecommendedCardProps['labelVariantMobile'];
  placement: UpsellPlacement;
}) => {
  const show = useShowTinyPlusUpsell(kit);
  const { trackEventOnce } = useAnalytics();

  useEffect(() => {
    if (show) {
      trackEventOnce('Tiny Plus Contextual Card Viewed', placement, {
        placement,
      });
    }
  }, [show, placement, trackEventOnce]);

  if (!show) return null;

  return (
    <RecommendedCard
      {...getTinyPlusUpsellCard(title, label, imgStyles)}
      titleContainerClassName={titleContainerClassName}
      leftColumnStyles={leftColumnStyles}
      titleVariantMobile={titleVariantMobile}
      labelVariantMobile={labelVariantMobile}
      analyticsEventName='Tiny Plus Contextual Card Clicked'
      className={className}
      clickable={{
        href: urls.TINY_PLUS_UPGRADE_OFFER,
        text: 'Upgrade to Tiny+',
        isExternal: true,
        placement,
      }}
    />
  );
};
